import { render, staticRenderFns } from "./InvoiceHistory.vue?vue&type=template&id=06324b5c&scoped=true"
import script from "./InvoiceHistory.vue?vue&type=script&lang=js"
export * from "./InvoiceHistory.vue?vue&type=script&lang=js"
import style0 from "./InvoiceHistory.vue?vue&type=style&index=0&id=06324b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06324b5c",
  null
  
)

export default component.exports